import { toast } from "react-toastify";

export const initSubmissionToast = (title, onCancel) => {
  return toast(
    <div className="row w-100">
      <div className="row w-100">
        <p className="toast-title fs-4 fw-bold">
          {title} <span id="progress-indicator">(0%)</span>
        </p>
      </div>
      <div className="row w-100 flex-grow-1">
        <small className="text-dark">
          Your files are being uploaded. This may take a moment, please stand by!
        </small>
        <small className="text-muted">*uploading progress depends on your internet speed.</small>
      </div>
      <div className="row justify-content-end w-100 flex-grow-1">
        <small
          className="d-flex justify-content-end text-danger fw-bold cursor-pointer"
          onClick={onCancel}
        >
          Cancel
        </small>
      </div>
    </div>,
    {
      autoClose: false,
      closeButton: false,
      closeOnClick: false,
      draggable: false,
      icon: false,
      type: "warning",
      className: "d-none",
      toastId: "form-submittion",
      timeout: 2300
    }
  );
};

export const showProgressToast = (toastId) => {
  window.onbeforeunload = () => "Please wait until the data submitted!";
  toast.update(toastId, { className: "d-block", progress: 0.05 });
  const indicator = document.getElementById("progress-indicator");
  if (indicator) {
    indicator.innerText = "(0%)";
  }
};

export const updateProgressToast = (toastId, progressEvent) => {
  try {
    window.onbeforeunload = () => "Please wait until the data submitted!";
    const done = progressEvent.loaded === progressEvent.total;
    const percentage = (progressEvent.loaded * 100) / progressEvent.total;
    toast.update(toastId, {
      className: "d-block",
      progress: done ? 0.99 : percentage / 100
    });
    const indicator = document.getElementById("progress-indicator");
    if (indicator) {
      indicator.innerText = done ? "(Processing...)" : `(${+percentage.toFixed(2)}%)`;
    }
  } catch (error) {
    console.error(error);
  }
};

export const hideProgressToast = (toastId) => {
  window.onbeforeunload = null;
  toast.update(toastId, { className: "d-none", progress: 0 });
};
